"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Items = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const item_1 = require("./item");
const ramda_1 = require("ramda");
exports.Items = (0, react_1.memo)(({ items, onItemClick, checkSelection }) => {
    const [isOpen, toggleCollapse] = (0, react_1.useState)(Object.create(null));
    const isFlat = (0, react_1.useMemo)(() => {
        return !items.some((i) => i.children);
    }, [items]);
    const toggle = (0, react_1.useCallback)((item, isOpen) => {
        toggleCollapse((oldValue) => {
            const toggledValue = (0, ramda_1.isNil)(isOpen) ? !Boolean(oldValue[item.id]) : isOpen;
            if (oldValue[item.id] !== toggledValue) {
                return Object.assign(Object.assign({}, oldValue), { [item.id]: toggledValue });
            }
            return oldValue;
        });
    }, [toggleCollapse]);
    const itemComponents = (0, react_1.useMemo)(() => items.map((item, index, list) => (react_1.default.createElement(item_1.Item, { key: item.id, item: item, toggle: toggle, isOpen: Boolean(isOpen[item.id]), isFlat: isFlat, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: index === list.length - 1 }))), [toggle, isOpen, isFlat, items, checkSelection]);
    return react_1.default.createElement(wl_ui_kit_1.List, null, itemComponents);
});
